import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MarkdownService, provideMarkdown } from 'ngx-markdown';
import {
  AngularMarkdownEditorModule,
  EditorInstance,
  EditorOption,
} from 'angular-markdown-editor';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-markdown-editor',
  standalone: true,
  imports: [AngularMarkdownEditorModule, FormsModule],
  templateUrl: './markdown-editor.component.html',
  styleUrl: './markdown-editor.component.scss',
  providers: [provideMarkdown()],
})
export class MarkdownEditorComponent
  implements OnInit, OnChanges, AfterViewInit
{
  @Input() prompt = '';
  @Input() height = '';
  @Input() textareaId = '';
  @Output() promptChange = new EventEmitter<string>();

  bsEditorInstance!: EditorInstance;
  markdownText = '';
  showEditor = true;
  editorOptions!: EditorOption;

  constructor(
    private readonly elm: ElementRef,
    private markdownService: MarkdownService,
  ) {}

  ngOnInit() {
    this.editorOptions = {
      autofocus: false,
      iconlibrary: 'fa',
      savable: false,
      language: 'en',
      resize: 'enable',
      height: 100,
      hiddenButtons: [
        'bootstrap-markdown-cmdStrikethrough',
        'bootstrap-markdown-cmdUrl',
        'bootstrap-markdown-cmdImage',
      ],
      onFullscreenExit: () => this.hidePreview(),
      onShow: (e) => (this.bsEditorInstance = e),
      parser: (val) => this.parse(val),
    };
  }

  ngAfterViewInit() {
    const textarea = this.elm.nativeElement.querySelector(
      `textarea#${this.textareaId}`,
    );
    if (this.height) {
      textarea.style.height = this.height;
    } else {
      textarea.style.height = '6em';
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['prompt'] !== undefined) {
      const prompt: string = changes['prompt'].currentValue;
      if (!prompt) {
        // Hacked: angular-markdown-editorコンポーネントが、内部で空文字の場合はngModelでの値更新をしないようにしているため、強制的に空白にする。
        // https://github.com/ghiscoding/angular-markdown-editor/blob/703020a9944e42b655bd231bd643e5b8f4702b9e/src/lib/angular-markdown-editor/angular-markdown-editor.component.ts#L130
        this.elm.nativeElement.querySelector('textarea').value = '';

        // 空文字の場合、Preview表示を解除する
        this.hidePreview();
      }
    }
  }

  onChange(event: { getContent: () => string }) {
    // for example show textarea new body content
    this.prompt = event.getContent();
    this.promptChange.emit(this.prompt);
  }

  hidePreview() {
    if (this.bsEditorInstance && this.bsEditorInstance.hidePreview) {
      this.bsEditorInstance.hidePreview();
    }
  }

  parse(inputValue: string) {
    const previewValue = this.replaceNewLine(inputValue);
    const markedOutput = this.markdownService.parse(previewValue);
    this.highlight();

    return markedOutput;
  }

  /**
   * 改行コードを置き換える
   * @param promptValue プロンプトの値
   * @returns 置換結果
   */
  private replaceNewLine = (promptValue: string): string => {
    const parts = promptValue.split('```');

    // コードブロックが無い場合
    if (parts.length <= 1) {
      return promptValue.replaceAll(/\n/g, '    \n');
    }

    for (let i = 0; i < parts.length; i++) {
      // コードブロック外の部分だけ改行を <br/> に変換
      if (i % 2 === 0) {
        parts[i] = parts[i].replaceAll(/\n/g, '    \n');
      }
    }
    return parts.join('```');
  };

  /** highlight all code found, needs to be wrapped in timer to work properly */
  highlight() {
    setTimeout(() => {
      this.markdownService.highlight();
    });
  }
}
